import { useWidget } from 'components/Widget/useWidget';
import NinjaTable from 'components/tables/NinjaTable';
import React, { useMemo } from 'react';
import { useWidgetDate } from 'store/redux/states/dates/dates.hooks';
import WidgetsCommonColumns from 'components/widgets/components/WidgetsCommonColumns';
import { ChannelsFormatter } from 'components/tables/NinjaTable/formatters';

const ProfitsAndLossesByChannelsTable = ({ height, widget_key }) => {
  const { dates } = useWidgetDate(widget_key);
  const { filters } = useWidget();

  const columns = useMemo(() => {
    const commonColumns = WidgetsCommonColumns().map((col) => ({
      ...col,
      name: col.definition ?? col.name,
    }));

    return [
      {
        name: 'Channel',
        key: 'network',
        minWidth: 160,
        resizable: true,
        frozen: true,
        renderCell: ({ row }) => <ChannelsFormatter channel={row.network} />,
        renderSummaryCell: () => 'Totals',
      },
      ...commonColumns,
    ];
  }, [dates]);

  return (
    <NinjaTable
      columns={columns}
      dataProvider='channelsProfitAndLoss'
      queryParams={{ ...dates, ...filters }}
      cardProps={{ disable: true }}
      maxHeight={height}
      disableFooter
      tableProps={{ template: 'channels-widget' }}
    />
  );
};

export default ProfitsAndLossesByChannelsTable;
